import script from "./Pc.vue?vue&type=script&setup=true&lang=js"
export * from "./Pc.vue?vue&type=script&setup=true&lang=js"

import "./Pc.vue?vue&type=style&index=0&id=896a99da&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-896a99da"]])

export default __exports__